module.exports = __webpack_public_path__ + "img/login_page_image2.7747cb7b.jpg";